import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const privilege_role_center = createAsyncThunk(
  'WealthLevel/privilege_role_center',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/privilege/privilege_role_center',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const receive_mission_bubble = createAsyncThunk(
  'WealthLevel/receive_mission_bubble',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/rank/receive_mission_bubble',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_wealth_homepage = createAsyncThunk(
  'WealthLevel/get_wealth_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/rank/get_wealth_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_wealth_right_detail = createAsyncThunk(
  'WealthLevel/get_wealth_right_detail',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/rank/get_wealth_right_detail',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data?.data?.right_list || []
  }
)

export interface InitialStateType {
  level: any
  home: any
  detail: Array<any>
}

const initialState: InitialStateType = {
  level: {},
  home: {},
  detail: [],
}

export const WealthLevelSlice = createSlice({
  name: 'WealthLevelSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(privilege_role_center.fulfilled, (state, action) => {
      Object.assign(state, {
        level: {
          ...state.level,
          ...action.payload,
        },
      })
    })
    builder.addCase(get_wealth_right_detail.fulfilled, (state, action) => {
      Object.assign(state, {
        detail: action.payload || {},
      })
    })
    builder.addCase(get_wealth_homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        home: action.payload || {},
      })
    })
  },
})
export default WealthLevelSlice.reducer
export const WealthLevelActions = WealthLevelSlice.actions

export const useWealthLevelState = () => {
  const data = useSelector((state) => {
    return state.Animal_Tapir
  })
  return data
}
